// ============================================
// FILE 2: stateManagers/services/authService.ts
// ============================================
import axios from 'axios';
import { API_BASE_URL } from '../../apiSetup/apiConfig';

// DON'T use apiClient for login - it doesn't need authentication
export const login = async (username: string, password: string, deviceId?: string) => {
  console.log('🔐 Attempting login for:', username);
  console.log('📍 Login URL:', `${API_BASE_URL}api/login-v2`);

  try {
    const response = await axios.post(`${API_BASE_URL}api/login-v2`, {
      username,
      password,
      device_id: deviceId,
    });

    console.log('✅ Login response:', response.data);
    return response;
  } catch (error: any) {
    console.error('❌ Login failed:', error.response?.data || error.message);
    throw error;
  }
};

export const refreshToken = async (refreshTokenValue: string) => {
  console.log('🔄 Refreshing token...');
  return await axios.post(`${API_BASE_URL}api/refresh-v2`, {
    refresh_token: refreshTokenValue,
  });
};

// NOTE: no /logout or /logout-all routes exist in RegisterAuthRoutes yet.
// These will 404 until backend routes are added. Left in place so the
// frontend at least clears local state even if the network call fails.
export const logout = async (accessToken: string, refreshTokenValue: string) => {
  console.log('👋 Logging out...');
  const response = await axios.post(`${API_BASE_URL}api/logout`, {
    refresh_token: refreshTokenValue,
  }, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response;
};

export const logoutAllDevices = async (accessToken: string) => {
  console.log('👋 Logging out all devices...');
  const response = await axios.post(`${API_BASE_URL}api/logout-all`, {}, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response;
};